/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';
import { ElBadgeComponent } from './badge.component';

@NgModule({
  exports: [ ElBadgeComponent ],
  declarations: [ ElBadgeComponent ],
})
export class ElBadgeModule { }
